import { Flex, customStyled } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const InfoContainer = customStyled(Flex)(({ theme: { fontSizes, radii, space } }) => ({
  alignItems: 'center',
  backgroundColor: COLORS.INFO_25,
  borderRadius: radii[2],
  fontSize: fontSizes[2],
  padding: space[3],
  color: COLORS.BLUE_600,
}));

export const InfoIconWrapper = customStyled(Flex)(({ theme }) => ({
  marginRight: theme.space[3],
  minWidth: theme.space[3],
}));
